module.exports = __webpack_public_path__ + "0e6f2e7eb65787f14a4a75b8e5ebfb2e.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/16/Portal_release.png
// module id = 242
// module chunks = 0